import { helpers } from "../helpers/helpers";

    export const getPaymentOrders = async function (userId: string, dateFrom: string, dateTo: string, paymentMethodTypeId: number, providerTypeId: number): Promise<any> {

        const baseCashierApiUrl = helpers.getApiUrls()['cashierApiUrl'];
        const transactionsEndpointUrl = '/v1/paymentorder';
        const queryParams = `UserId=${userId.toString()}&DateFrom=${dateFrom}&DateTo=${dateTo}&PaymentMethodTypeId=${paymentMethodTypeId}&ProviderTypeId=${providerTypeId}`;

        const apiUrl = `${baseCashierApiUrl}${transactionsEndpointUrl}?${queryParams}`;

        const fetchOptions = {
            method: 'GET',
            headers: {
                'Accept-Language': helpers.getCurrentCulture(),
                'X-SKS-MID': helpers.getModuleId(),
                'Authorization': `Bearer ${helpers.getBearerToken()}`
            },
        };

        try {
            const response = await fetch(apiUrl, fetchOptions);

            if (!response.ok) {
                throw new Error(`Error: ${response.status}`);
            }

            const transactions = await response.json();

            return transactions;
        } 
        catch (error) {
            console.error('Failed to fetch transactions:', error);
            return {};
        }
    };

    const removeExceptions =  function(elems: Element[]) { //because exceptions...
        return elems.filter(elem => elem.classList.contains('helpButton') === false && elem.classList.contains('footerMenu') === false);
    };
    
    const isVisible = function(elem: Element) {
        if (!(elem instanceof Element)) throw Error('DomUtil: elem is not an element.');
        const style = getComputedStyle(elem);
        if (style.display === 'none') return false;
        if (style.visibility !== 'visible') return false;
        if (parseFloat(style.opacity) < 0.1) return false;
        if ((elem as HTMLElement).offsetWidth + (elem as HTMLElement).offsetHeight + elem.getBoundingClientRect().height +
            elem.getBoundingClientRect().width === 0) {
            return false;
        }
        const elemCenter   = {
            x: elem.getBoundingClientRect().left + (elem as HTMLElement).offsetWidth / 2,
            y: elem.getBoundingClientRect().top + (elem as HTMLElement).offsetHeight / 2
        };
        if (elemCenter.x < 0) return false;
        if (elemCenter.x > (document.documentElement.clientWidth || window.innerWidth)) return false;
        if (elemCenter.y < 0) return false;
        if (elemCenter.y > (document.documentElement.clientHeight || window.innerHeight)) return false;
        let pointContainer: Element = document.elementFromPoint(elemCenter.x, elemCenter.y);
        do {
            if (pointContainer === elem) return true;
        } while (pointContainer = pointContainer.parentNode as Element);
        return false;
    };
    
    export const checkForOverlays = function() {   
        let isOverlayVisible = false;
        const potentialOverlays = document.querySelectorAll('div, section, article, aside');
        
        let overlays = Array.from(potentialOverlays).filter(elem => {
            const style = window.getComputedStyle(elem);
            return style.position === 'fixed' ||
                style.position === 'absolute' &&
                parseInt(style.zIndex, 10) > 1000 &&
                style.top === '0px' &&
                style.left === '0px' &&
                (style.width === '100%' || style.width === window.innerWidth + 'px') &&
                (style.height === '100%' || style.height === window.innerHeight + 'px');
        });
        
        overlays = removeExceptions(overlays);

        if (overlays.length > 0) {        
            overlays.forEach(overlay => {
                if(isVisible(overlay)) {
                    isOverlayVisible = true;
                    console.log('Overlay(s) found:', overlay);
                };
            })      
            return isOverlayVisible;
        } else {
            console.log('No overlays found.');
            return isOverlayVisible;
        }
    };

    export const getFromStorage = function(_keyName: string): any | null {
        return JSON.parse(sessionStorage.getItem(_keyName)) || null;
      }
      
    export const setToStorage = function(_keyName: string, _sessionValue: any): void {
        sessionStorage.setItem(_keyName, JSON.stringify(_sessionValue));
    }
    

